import React, { useEffect, useState } from 'react';
import { OpointAuthContext, OpointAuthErrorContext, OpointAuthStateContext, OpointImpersonationLoadingContext, } from './auth.js';
import { Auth, AuthError } from '@opoint/authjs';
function useCreateOpointAuth(host, callback, options) {
    const [authState, setAuthState] = useState(undefined);
    const [impersonationLoading, setImpersonationLoading] = useState(false);
    const [error, setError] = useState();
    if (options?.rethrowErrors && error)
        throw error;
    class ReactAuth extends Auth {
        constructor(host = 'https://auth.opoint.com', callback, options) {
            super(host, callback, options);
            this.options = this.options;
            this.options.rethrowErrors = options?.rethrowErrors ?? false;
        }
        async logout() {
            const result = await super.logout();
            setAuthState(null);
            return result;
        }
        async getState(noCache) {
            try {
                const result = await super.getState(noCache);
                setAuthState(result);
                setError(undefined);
                return result;
            }
            catch (e) {
                if (e instanceof AuthError || e instanceof TypeError) {
                    setError(e);
                }
            }
            return null;
        }
        async impersonate(id, 
        // eslint-disable-next-line camelcase
        privileges_index) {
            setImpersonationLoading(true);
            const result = await super.impersonate(id, privileges_index);
            const state = await this.getState();
            setAuthState(state);
            setImpersonationLoading(false);
            return result;
        }
    }
    const [auth] = useState(new ReactAuth(host, callback, options));
    return [auth, authState, impersonationLoading, error];
}
/**
 * Provides a scope within all the hooks will work.
 * @param host - The hostname of the API you want to use. This must be same-site with the current origin (i.e cookes considered first-party).
 * @param callback - The callback URL after a successful login.
 * @param options - AuthReactOptions describing further behaviour.
 */
export const OpointAuthProvider = ({ children, host, callback, options }) => {
    const [auth, authState, impersonationLoading, error] = useCreateOpointAuth(host, callback, options);
    // Initial load
    useEffect(() => {
        auth.getState();
    }, []);
    useEffect(() => {
        // Revalidate when the window regains focus
        const onFocus = () => {
            auth.getState();
        };
        window.addEventListener('focus', onFocus);
        return () => window.removeEventListener('focus', onFocus);
    }, []);
    return (React.createElement(OpointAuthContext.Provider, { value: auth },
        React.createElement(OpointAuthStateContext.Provider, { value: authState },
            React.createElement(OpointImpersonationLoadingContext.Provider, { value: impersonationLoading },
                React.createElement(OpointAuthErrorContext.Provider, { value: error }, children)))));
};
//# sourceMappingURL=authProvider.js.map